
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqY64Bw12o3NgY3BcImguwXiLCqP83XLt5_AK5FERve4gMeta } from "/codebuild/output/src2630089308/src/src/pages/faq.vue?macro=true";
import { default as menu9OxVM7oAcsu06k_45MzjGnk30eQutvG1ioPCH7CSrYDxIMeta } from "/codebuild/output/src2630089308/src/src/pages/menu.vue?macro=true";
import { default as indexbIDiW_8P6NnuQusenJeiIxtP8a6NFmFM64y8KW9g_aMMeta } from "/codebuild/output/src2630089308/src/src/pages/index.vue?macro=true";
import { default as contact_45AKMX0f0UgXAcxKSbZe1UmAZ_2cxyQ8dZQGtCDMQ334Meta } from "/codebuild/output/src2630089308/src/src/pages/contact.vue?macro=true";
import { default as tutorialf23wGwuvl13TLLORyaVbWzpcy6TkmGqcAHD6oBVs118Meta } from "/codebuild/output/src2630089308/src/src/pages/tutorial.vue?macro=true";
import { default as agreementBN5CST7dUUVWuzvo_45owhicD8PqLgSuyVus_xOBJt_dsMeta } from "/codebuild/output/src2630089308/src/src/pages/agreement.vue?macro=true";
import { default as about_45passiJ_ZIW3TdC96BztbAzQmVgFHu69XJ9_45ZYtppDRzBc9YMeta } from "/codebuild/output/src2630089308/src/src/pages/about-pass.vue?macro=true";
import { default as indexJlE7zppqmDM4wz6eW1WGEUh97BxqwcFGScX65_oLRLAMeta } from "/codebuild/output/src2630089308/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93Q1j8lACKoEeZzbmmCz3zoFPz3drq2YP9TuhRxY87y88Meta } from "/codebuild/output/src2630089308/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancek5p7GrVOUEWX_457LD74SUdcr_nqpuiiymgn_RWZZoNXwMeta } from "/codebuild/output/src2630089308/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93DkuOXBNZIGI4JMTfGGkHtWaqtLYvKAF42CSIXu2Ol4MMeta } from "/codebuild/output/src2630089308/src/src/pages/notice/[id].vue?macro=true";
import { default as indexF4rMtbNarCtbFtB8CHDV532wmnjAWb15elmjENsWeJ0Meta } from "/codebuild/output/src2630089308/src/src/pages/coupon/index.vue?macro=true";
import { default as indexHWJNNWU1dwRfYWbWOOZBQTpWrRZf94MLHHveoRm7iREMeta } from "/codebuild/output/src2630089308/src/src/pages/mypage/index.vue?macro=true";
import { default as indexQGaVMSFV4SIuMdF0tx22IrpLOz5yN97G6RzArBr5gsQMeta } from "/codebuild/output/src2630089308/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93x7XY03xi3WjD786wzAjkBYe2ech5M9gVq46cCPWvd7sMeta } from "/codebuild/output/src2630089308/src/src/pages/parking/[id].vue?macro=true";
import { default as indexVwFPK7uWEttQddcPPBH9stK5bc6uLiW5k2UHpJDuJjsMeta } from "/codebuild/output/src2630089308/src/src/pages/history/index.vue?macro=true";
import { default as indexj_hQ3Jzr5sU_eJN80Z67ob5WCYa8ca1johZpS0IYKcsMeta } from "/codebuild/output/src2630089308/src/src/pages/monthly/index.vue?macro=true";
import { default as indexQUTZVFNzYe27D_45vA0PsshUPVcd2fRIcyTFlivnW1ZV0Meta } from "/codebuild/output/src2630089308/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexpj5BeCE0Tc_45Dy55stxigwXkCOKqeOQSxUX8bJ22ppC0Meta } from "/codebuild/output/src2630089308/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviucxi8z6iDnUX3nmC01aFKIkhbHHJ4O7U_45UdOhHByELgMeta } from "/codebuild/output/src2630089308/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit_45x_bz7wUr3yyXObBwPQHANXmfaScYLX14tzbUrRq6ycMeta } from "/codebuild/output/src2630089308/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement0YlEhwJpOxUCGuq6RsmtP_afy844BXV_LoW2qHgfL4gMeta } from "/codebuild/output/src2630089308/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexayVgfN3Kx3ROmid1_45YGHdPhiijr40QeBKZNDBl3IM0QMeta } from "/codebuild/output/src2630089308/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dZV9SyOERMn0COZemtoVl9Ub5i4jPApLY36J5Paep4sIMeta } from "/codebuild/output/src2630089308/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmEjerJNAdsxrBg_45jOHnt1Zbrf2f3kwtALsyERkvO8cIkMeta } from "/codebuild/output/src2630089308/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index1mxGLM28qQRJtoOCIkGCSkdXvl6pkk500q5QkNGLj14Meta } from "/codebuild/output/src2630089308/src/src/pages/card/create/index.vue?macro=true";
import { default as index27Mev0k4wrzhTEdG4E62fyxM1K1K6ATpNbWeR3mn3bEMeta } from "/codebuild/output/src2630089308/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm6b9rSyqNZAy2c9T6RQBLdio_45OjiLv0mpsEQjqciNtHAMeta } from "/codebuild/output/src2630089308/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirm9WG1t3F948P6AjbgENFIeTuCbtXpU8AW5r8UMRWN6UoMeta } from "/codebuild/output/src2630089308/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeVEwUR40AExyiilQFlablTOFE9jBmPpDrzRS1Et_45Q_oEMeta } from "/codebuild/output/src2630089308/src/src/pages/membership/complete.vue?macro=true";
import { default as registerARdTXVwHlArN34PFgyRErqHRTJguTvveH9pJIXx4BB4Meta } from "/codebuild/output/src2630089308/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93PUGrUMfgRKs4tLPpuasnLaenJo9DnBA_45lktX2uukBj8Meta } from "/codebuild/output/src2630089308/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmenwG_hqNzm3JZXlL8x_45r2SYQqq0YYP1Hl_4555t0CW39YMeta } from "/codebuild/output/src2630089308/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93PgL_K1PboTM_45MkaADmhnX2CZSMlLwO0G5FZ9lw8qP_sMeta } from "/codebuild/output/src2630089308/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as index2mMQSiK61ewwZUNobBBPhZVU9sxEKTZ741Q6ShQvDX0Meta } from "/codebuild/output/src2630089308/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codegvdMO_45YxgHreF3p145dWSL9V3TPR1Ur6J6ZAsEYdalIMeta } from "/codebuild/output/src2630089308/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeyUsi6B7HolbsLfqKCeuwTcJOJ4JC1GVHsHVw_zIqOcYMeta } from "/codebuild/output/src2630089308/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeudZDd_45O8ZnJeW32mtcxDgrIkdLLgjb1NqWeOUoCScCUMeta } from "/codebuild/output/src2630089308/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerOYtF_QN6sU_45kzWzXUlk_45tr8wia9VdJ2KymD14teLj_45AMeta } from "/codebuild/output/src2630089308/src/src/pages/contact-form/register.vue?macro=true";
import { default as completePgPGn9dTy0uYrg71l8SMA9IPhJc9EIhcs50M1TwA05sMeta } from "/codebuild/output/src2630089308/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexzag3g6Cv95x4wBaPabDJ4BmfT88J9Edc77oe5DKz1HIMeta } from "/codebuild/output/src2630089308/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmIBsBpZfqg1rf_J1_45Dye8grNn0lGvMLZ4KbPFyhDUtzkMeta } from "/codebuild/output/src2630089308/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete0SFsgdRWEauUXV_45HLROdeIV_7vFf3E4aYTGUp93T_k4Meta } from "/codebuild/output/src2630089308/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexLjU3KO63MTqkHj4RXc9eX3LhYDNn1mpj_8NUvYfSYBsMeta } from "/codebuild/output/src2630089308/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93jDtBk8_6sOv_45yKyynqe3HhzzUnIa2d7gKmuNk1nRAXsMeta } from "/codebuild/output/src2630089308/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeVHEFIYYmPzomxUwt_pFp28EkRLsqwYVok148k64zikgMeta } from "/codebuild/output/src2630089308/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasXrLW9ftmoITzb2BJqrbSu22rzCEwhtU1g5A0611D7zQMeta } from "/codebuild/output/src2630089308/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sample8V3YZLhmXOR3RmeaOujbnp2k8vOmYreVpDjnfCuSbmwMeta } from "/codebuild/output/src2630089308/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailZvjmTzwxoxERtUs_45w1ZFUGf03Yg4UUuTQClGPEW4jGMMeta } from "/codebuild/output/src2630089308/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmzMy1ZantUZ0kqPefS1f_45EG6CHF8neuDRo7ifFYrkJoUMeta } from "/codebuild/output/src2630089308/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentGTIjh4KtAen5NDA705y4kyJR9CS9iLX8dyoHGggPD_wMeta } from "/codebuild/output/src2630089308/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirm_GD6q4P5JFpe7uUdkp5FByV9q1JaQ_45vZlm0n_4586jVXoMeta } from "/codebuild/output/src2630089308/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatejBADjY99N04eAeIpcHavoDSgl_45niNCcGviqXFRF2y6cMeta } from "/codebuild/output/src2630089308/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeN88GpMe7TSthuXj27JuA1tBOMPy2vEaBGKngUAifvUAMeta } from "/codebuild/output/src2630089308/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeP9PQaj9Og21FHp0J2OJ2bK9QF8KG_45LDEzEtf5S_45GlFMMeta } from "/codebuild/output/src2630089308/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordYVEORYhjcihWqWrewF5gRr5hLaz3dHoMUXovoLzzo8kMeta } from "/codebuild/output/src2630089308/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasv8_REstMxi0N_45H_XfN1J1iFci324m24rVbjjbBlSRCcMeta } from "/codebuild/output/src2630089308/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerrjLt2UUS_Ztn8NBCI8aYwt5vKeo8Z0itRSPC2v1sedEMeta } from "/codebuild/output/src2630089308/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codePlAjBBVtIGXP0jpGsDTDMYSkAsaD285gYjR3WQGE10UMeta } from "/codebuild/output/src2630089308/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexeOSUcXaas1j_45n909GvhF2qS9GDU63fIPj0d_iPC7K1sMeta } from "/codebuild/output/src2630089308/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexS_sUlgbi05i6CwzXHvTgHyUUatmCIiWfx6O2C_r0rroMeta } from "/codebuild/output/src2630089308/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexMDShjXZ7N4qduuOCq2DCjyKaBrZKgijI7bPT0J1ucpgMeta } from "/codebuild/output/src2630089308/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexqdvW_45sZBFTctH5hwAJscfvaGQeax1IMjqraNgaayQgUMeta } from "/codebuild/output/src2630089308/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update6Z_451Qr0as1UdiUbvC15kK8IbhYw8jzVs1XyVFx4Mk4YMeta } from "/codebuild/output/src2630089308/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completePogbYWOpTEXHjGG4HWZeqh6yjaPSzQw5aVO6EcCf2UgMeta } from "/codebuild/output/src2630089308/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmcSagStFUQjnPEtnf_454JGaYPx2vYSfwX_45AvPz2L3JUV8Meta } from "/codebuild/output/src2630089308/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as index3tg1oTIa8n17uO_IrEU5m0x_15e3iKrEV3So_45G_451W3YMeta } from "/codebuild/output/src2630089308/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeOYNqXzE1C0hYF3hGuKm2i_rHHHmbkpyVUS_45jzEqAdlAMeta } from "/codebuild/output/src2630089308/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update4EyUydciFJx4q54qAg87NtqZgL2GflWyqW6BWqeIM8UMeta } from "/codebuild/output/src2630089308/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexNUIHJ2WW7GL4huMZlSRx2L2leJbNZRDWoCFxQ8zutREMeta } from "/codebuild/output/src2630089308/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexCZwbs63M6h3wP7wbNsY5GLvhNC2TxQviAOEfdDUAjvEMeta } from "/codebuild/output/src2630089308/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completerrbYM5AKdtCAfTehShrQselU9nW70rvPgKBWkPxwOY4Meta } from "/codebuild/output/src2630089308/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexxCOJCRDwvu6kPexuMuzq32shpqjfQ5B_45YN19YnvQZFQMeta } from "/codebuild/output/src2630089308/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeEKWxpr141rXBouymVP3zVKiU1TyHZBTHdbOzuN5KyYMMeta } from "/codebuild/output/src2630089308/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexQG4dA0vh8uIDF9VmzZ3TPV5y72UOY_45qsl_QIVNxQaHcMeta } from "/codebuild/output/src2630089308/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexm3KmUl0XydLE360MbeJzJ0iyTiBAWnj0e4nqEcEic_YMeta } from "/codebuild/output/src2630089308/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexjjXeh3Etlh_45ij6CpDwAdFuXlNKVinTFVZrpWyGwBgCkMeta } from "/codebuild/output/src2630089308/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatefFiuqIR4qltTIue1uPBGF_45Ac4PEbFRrpnPMOU6OZzs8Meta } from "/codebuild/output/src2630089308/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmGPpyAWiZrRJqppb7eHDFJ8HNuRaWPDAKxLZNauLDolUMeta } from "/codebuild/output/src2630089308/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu9OxVM7oAcsu06k_45MzjGnk30eQutvG1ioPCH7CSrYDxIMeta || {},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexbIDiW_8P6NnuQusenJeiIxtP8a6NFmFM64y8KW9g_aMMeta || {},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexF4rMtbNarCtbFtB8CHDV532wmnjAWb15elmjENsWeJ0Meta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2630089308/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexVwFPK7uWEttQddcPPBH9stK5bc6uLiW5k2UHpJDuJjsMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2630089308/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexQUTZVFNzYe27D_45vA0PsshUPVcd2fRIcyTFlivnW1ZV0Meta || {},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexpj5BeCE0Tc_45Dy55stxigwXkCOKqeOQSxUX8bJ22ppC0Meta || {},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index1mxGLM28qQRJtoOCIkGCSkdXvl6pkk500q5QkNGLj14Meta || {},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm6b9rSyqNZAy2c9T6RQBLdio_45OjiLv0mpsEQjqciNtHAMeta || {},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirm9WG1t3F948P6AjbgENFIeTuCbtXpU8AW5r8UMRWN6UoMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2630089308/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeVEwUR40AExyiilQFlablTOFE9jBmPpDrzRS1Et_45Q_oEMeta || {},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerARdTXVwHlArN34PFgyRErqHRTJguTvveH9pJIXx4BB4Meta || {},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmenwG_hqNzm3JZXlL8x_45r2SYQqq0YYP1Hl_4555t0CW39YMeta || {},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codegvdMO_45YxgHreF3p145dWSL9V3TPR1Ur6J6ZAsEYdalIMeta || {},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeyUsi6B7HolbsLfqKCeuwTcJOJ4JC1GVHsHVw_zIqOcYMeta || {},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeudZDd_45O8ZnJeW32mtcxDgrIkdLLgjb1NqWeOUoCScCUMeta || {},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerOYtF_QN6sU_45kzWzXUlk_45tr8wia9VdJ2KymD14teLj_45AMeta || {},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmIBsBpZfqg1rf_J1_45Dye8grNn0lGvMLZ4KbPFyhDUtzkMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete0SFsgdRWEauUXV_45HLROdeIV_7vFf3E4aYTGUp93T_k4Meta || {},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexLjU3KO63MTqkHj4RXc9eX3LhYDNn1mpj_8NUvYfSYBsMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeVHEFIYYmPzomxUwt_pFp28EkRLsqwYVok148k64zikgMeta || {},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sample8V3YZLhmXOR3RmeaOujbnp2k8vOmYreVpDjnfCuSbmwMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailZvjmTzwxoxERtUs_45w1ZFUGf03Yg4UUuTQClGPEW4jGMMeta || {},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmzMy1ZantUZ0kqPefS1f_45EG6CHF8neuDRo7ifFYrkJoUMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentGTIjh4KtAen5NDA705y4kyJR9CS9iLX8dyoHGggPD_wMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirm_GD6q4P5JFpe7uUdkp5FByV9q1JaQ_45vZlm0n_4586jVXoMeta || {},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeN88GpMe7TSthuXj27JuA1tBOMPy2vEaBGKngUAifvUAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeP9PQaj9Og21FHp0J2OJ2bK9QF8KG_45LDEzEtf5S_45GlFMMeta || {},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordYVEORYhjcihWqWrewF5gRr5hLaz3dHoMUXovoLzzo8kMeta || {},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerrjLt2UUS_Ztn8NBCI8aYwt5vKeo8Z0itRSPC2v1sedEMeta || {},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codePlAjBBVtIGXP0jpGsDTDMYSkAsaD285gYjR3WQGE10UMeta || {},
    component: () => import("/codebuild/output/src2630089308/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2630089308/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]